import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const LocationMaster = {
	name: NAME,
	apiProvider,
	router,
};
